module.exports = __webpack_public_path__ + "static/media/marca-alelo-blue.966b5ba4.png";